// ── Why a reading did not arrive ───────────────────────────────────
//
// 5-1 measures a failure rate, and a rate needs its modes kept apart: the
// service being busy says nothing about the protocol, while a response that is
// not a reading says everything about it. One catch-all would record both as
// the same event and the measurement would be unreadable.
//
// This lives in its own module so the check can run the real classifier rather
// than a copy of it. A copy in a test file drifts from the code it claims to
// describe, and then the test is evidence about the copy.

// The stages the proxy reports. `upstream` and `model-output` both arrive as
// 502 and are only distinguishable because api/mirror.js says which half failed.
export const FAILURE_REASONS = [
  "congested",            // 429/529 after the proxy spent its retries
  "upstream",             // the call to Anthropic never completed
  "model-output",         // it completed; the body was not parseable JSON
  "schema-mismatch",      // parseable, past the API boundary, but not a reading
  "rejected",             // the proxy refused the request (400/405/500)
  "unparseable-response", // the proxy's own body was not JSON
  "unreachable",          // fetch threw in the browser: offline, blocked, aborted
];

// Returns null when nothing failed. `body` is the parsed response, or null if
// it would not parse; `isReading` is the client's own shape check, passed in so
// this module does not need to know what a reading looks like.
export function classifyFailure(httpStatus, body, isReading) {
  if (!body) return { reason: "unparseable-response", httpStatus };
  if (body.ok === false) {
    return {
      reason: body.stage || (httpStatus === 429 || httpStatus === 529 ? "congested" : "upstream"),
      httpStatus,
    };
  }
  if (body.error) return { reason: "rejected", httpStatus, detail: body.error?.message || null };
  if (!isReading(body.reading)) return { reason: "schema-mismatch", httpStatus };
  return null;
}
